import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';
import useConfirmModal from 'components/hooks/useConfirmModal';

const ConfirmDescription = (
  <>
    The following settings will be restored: <br />
    <br />
    Rule filters <br />
    Category order
    <br /> Benchmarks percentage
  </>
);

const RevertToDefault = ({ onClick }) => {
  const confirmModal = useConfirmModal();

  const _onClick = async () => {
    const isConfirmed = await confirmModal({
      title: 'Revert to default?',
      description: ConfirmDescription,
      confirmText: 'Revert'
    });
    if (!isConfirmed) return;

    onClick();
  };
  return (
    <LBButton onClick={_onClick} variant='ghost'>
      <Icon name='Refresh' color='black' />
      Revert to Default
    </LBButton>
  );
};

export default RevertToDefault;
